import React from 'react';

const PrintIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 7V3C5 2.44772 5.44772 2 6 2H14C14.5523 2 15 2.44772 15 3V7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 11H4C2.89543 11 2 10.1046 2 9V8C2 6.89543 2.89543 6 4 6H16C17.1046 6 18 6.89543 18 7V9C18 10.1046 17.1046 11 16 11H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 11H15V17C15 17.5523 14.5523 18 14 18H6C5.44772 18 5 17.5523 5 17V11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15"
      cy="8"
      r="0.5"
      fill="currentColor"
    />
  </svg>
);

export default PrintIcon;

